<template>
    <section dir="ltr" id="process" class="process">
        <div class="container">
            <div class="process-content" v-scrollanimation>
                <h3 class="process-title">
                    {{ $t('process.process_title') }}
                </h3>
                <p class="title">{{ $t('process.title') }}</p>
                <!-- <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-12 my-card">
                        <b-icon icon="lightbulb" class="process-icon"></b-icon>
                        <div class="card">
                            <h3 class="numbers">01</h3>
                            <h4 class="process-header">
                                Idea
                            </h4>
                            <div class="process-discription">
                                We communicate effectively to understand the idea and project requirements
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 my-card card-bottom">
                        <b-icon icon="journal-check" class="process-icon"></b-icon>
                        <div class="card">
                            <h3 class="numbers">02</h3>
                            <h4 class="process-header">
                                Planning
                            </h4>
                            <div class="process-discription">
                                We draw up implementation plans and suggest more features and solutions
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 my-card ">
                        <b-icon icon="code-slash" class="process-icon"></b-icon>
                        <div class="card">
                            <h3 class="numbers">03</h3>
                            <h4 class="process-header">
                                Development
                            </h4>
                            <div class="process-discription">
                                Programming and implementation interface design and database building
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 my-card card-bottom">
                        <b-icon icon="tools" class="process-icon"></b-icon>
                        <div class="card">
                            <h3 class="numbers">04</h3>
                            <h4 class="process-header">
                                Testing
                            </h4>
                            <div class="process-discription">
                                We test modules and functionality integrations and are bug-free
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="row larg-row" v-if="screenWidth >= 992">

                    <div class="col-lg-2" id="plan1">
                        <div class="card card-bottom my-tooltip-top">
                            <span class="my-tooltiptext-top">
                                <h6>PLAN</h6>
                                <p style="font-size: 13px;">Discription about plan</p>
                            </span>
                            <!-- <b-tooltip show target="plan1" custom-class="tooltip-top tech-tooltip">
                                <h6>PLAN</h6>
                                Discription about plan
                            </b-tooltip> -->
                            <img src="../assets/img/process/plan.webp" style="width: 50%" alt="icon"/>
                        </div>
                        <div class="card-border-bottom"></div>
                    </div>

                    <div class="col-lg-2 top" id="design1">
                        <div class="card card-top my-tooltip-bottom">
                            <img src="../assets/img/process/design.webp" style="width: 50%"  alt="icon"/>
                            <span class="my-tooltiptext-bottom">
                                <h6>DESIGN</h6>
                                <p style="font-size: 13px;">Discription about design</p>
                            </span>
                            <!-- <b-tooltip target="design1" placement="bottom" custom-class="tooltip-bottom tech-tooltip">
                                <h6>DESIGN</h6>
                                Discription about design
                            </b-tooltip> -->
                        </div>
                        <div class="card-border-top"></div>
                    </div>


                    <div class="col-lg-2 bottom" id="develop1">
                        <div class="card card-bottom my-tooltip-top">
                            <span class="my-tooltiptext-top">
                                <h6>DEVELOP</h6>
                                <p style="font-size: 13px;">Discription about develop</p>
                            </span>
                            <!-- <b-tooltip target="develop1" custom-class="tooltip-top tech-tooltip">
                                <h6>DEVELOP</h6>
                                Discription about develop
                            </b-tooltip> -->
                            <img src="../assets/img/process/develop.webp" style="width: 50%"  alt="icon"/>
                        </div>
                        <div class="card-border-bottom"></div>
                    </div>


                    <div class="col-lg-2 top" id="test1">
                        <div class="card card-top my-tooltip-bottom">
                            <img src="../assets/img/process/test.webp" style="width: 60%" alt="icon" />
                            <span class="my-tooltiptext-bottom">
                                <h6>TEST</h6>
                                <p style="font-size: 13px;">Discription about test</p>
                            </span>
                            <!-- <b-tooltip target="test1" placement="bottom" custom-class="tooltip-bottom tech-tooltip">
                                <h6>TEST</h6>
                                Discription about test
                            </b-tooltip> -->
                        </div>
                        <div class="card-border-top"></div>
                    </div>


                    <div class="col-lg-2 bottom" id="deploy1">
                        <div class="card card-bottom my-tooltip-top">
                            <span class="my-tooltiptext-top">
                                <h6>DEPLOY</h6>
                                <p style="font-size: 13px;">Discription about deploy</p>
                            </span>
                            <!-- <b-tooltip target="deploy1" custom-class="tooltip-top tech-tooltip">
                                <h6>DEPLOY</h6>
                                Discription about deploy
                            </b-tooltip> -->
                            <img src="../assets/img/process/deploy.webp" style="width: 55%"  alt="icon"/>
                        </div>
                        <div class="card-border-bottom"></div>
                    </div>
                    <div class="col-lg-2 top" id="launch1">
                        <div class="card card-top my-tooltip-bottom">
                            <img src="../assets/img/process/launch.webp" style="width: 55%" alt="icon" />
                            <span class="my-tooltiptext-bottom">
                                <h6>LAUNCH</h6>
                                <p style="font-size: 13px;">Discription about launch</p>
                            </span>
                            <!-- <b-tooltip target="launch1" placement="bottom" custom-class="tooltip-bottom tech-tooltip">
                                <h6>LAUNCH</h6>
                                Discription about launch
                            </b-tooltip> -->
                        </div>
                        <div class="card-border-top"></div>
                    </div>
                </div>







                <div class="med-row" v-else-if="screenWidth < 992">
                    <div class="row" style="flex-wrap: nowrap;">
                        <div class="col-md-6 twice" id="plan">
                            <div class="card card-bottom my-tooltip-top">
                                <span class="my-tooltiptext-top">
                                    <h6>PLAN</h6>
                                    <p style="font-size: 13px;">Discription about plan</p>
                                </span>
                                <!-- <b-tooltip show target="plan1" custom-class="tooltip-top tech-tooltip">
                                <h6>PLAN</h6>
                                Discription about plan
                            </b-tooltip> -->
                                <img src="../assets/img/process/plan.webp" style="width: 50%"  alt="icon"/>
                            </div>
                            <div class="card-border-bottom"></div>
                        </div>
                        <div class="col-lg-6 top" style="margin-top: -15px;" id="design">
                            <div class="card card-top my-tooltip-bottom">
                                <img src="../assets/img/process/design.webp" style="width: 50%"  alt="icon"/>
                                <span class="my-tooltiptext-bottom">
                                    <h6>DESIGN</h6>
                                    <p style="font-size: 13px;">Discription about design</p>
                                </span>
                                <!-- <b-tooltip target="design1" placement="bottom" custom-class="tooltip-bottom tech-tooltip">
                                <h6>DESIGN</h6>
                                Discription about design
                            </b-tooltip> -->
                            </div>
                            <div class="card-border-top"></div>
                        </div>
                    </div>



                    <div class="row" style="flex-wrap: nowrap;margin-top: -50px;">
                        <div class="col-md-6 twice" id="develop">
                            <div class="card card-bottom my-tooltip-top">
                                <span class="my-tooltiptext-top">
                                    <h6>DEVELOP</h6>
                                    <p style="font-size: 13px;">Discription about develop</p>
                                </span>
                                <!-- <b-tooltip target="develop1" custom-class="tooltip-top tech-tooltip">
                                <h6>DEVELOP</h6>
                                Discription about develop
                            </b-tooltip> -->
                                <img src="../assets/img/process/develop.webp" style="width: 50%" alt="icon" />
                            </div>
                            <div class="card-border-bottom"></div>
                        </div>
                        <div class="col-lg-6 top" style="margin-top: -15px;" id="test">
                            <div class="card card-top my-tooltip-bottom">
                                <img src="../assets/img/process/test.webp" style="width: 60%" alt="icon" />
                                <span class="my-tooltiptext-bottom">
                                    <h6>TEST</h6>
                                    <p style="font-size: 13px;">Discription about test</p>
                                </span>
                                <!-- <b-tooltip target="test1" placement="bottom" custom-class="tooltip-bottom tech-tooltip">
                                <h6>TEST</h6>
                                Discription about test
                            </b-tooltip> -->
                            </div>
                            <div class="card-border-top"></div>
                        </div>
                    </div>


                    <div class="row" style="flex-wrap: nowrap;margin-top: -50px;">
                        <div class="col-md-6 twice" id="deploy">
                            <div class="card card-bottom my-tooltip-top">
                                <span class="my-tooltiptext-top">
                                    <h6>DEPLOY</h6>
                                    <p style="font-size: 13px;">Discription about deploy</p>
                                </span>
                                <!-- <b-tooltip target="deploy1" custom-class="tooltip-top tech-tooltip">
                                <h6>DEPLOY</h6>
                                Discription about deploy
                            </b-tooltip> -->
                                <img src="../assets/img/process/deploy.webp" style="width: 55%" alt="icon" />
                            </div>
                            <div class="card-border-bottom"></div>
                        </div>
                        <div class="col-lg-6 top" style="margin-top: -15px;" id="launch">
                            <div class="card card-top my-tooltip-bottom">
                                <img src="../assets/img/process/launch.webp" style="width: 55%"  alt="icon"/>
                                <span class="my-tooltiptext-bottom">
                                    <h6>LAUNCH</h6>
                                    <p style="font-size: 13px;">Discription about launch</p>
                                </span>
                                <!-- <b-tooltip target="launch1" placement="bottom" custom-class="tooltip-bottom tech-tooltip">
                                <h6>LAUNCH</h6>
                                Discription about launch
                            </b-tooltip> -->
                            </div>
                            <div class="card-border-top"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Process",
    data() {
        return {
            lang: '',
            screenWidth: 0,
        };
    },
    methods: {
        onScreenResize() {
            window.addEventListener("resize", () => {
                this.updateScreenWidth()
            });
        },
        updateScreenWidth() {
            this.screenWidth = window.innerWidth
        },
    },
    mounted() {
        this.updateScreenWidth()
        this.onScreenResize()
    },
};
</script>

<style lang="scss">
.my-tooltip-top .my-tooltiptext-top {
    visibility: hidden;
    width: 150px;
    background-color: var(--main-blue);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 10px 5px 0px;
    position: absolute;
    z-index: 1;
    bottom: 120%;
    left: 35%;
    margin-left: -60px;    
    z-index: 99999999;
}

.my-tooltip-top .my-tooltiptext-top::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--main-blue) transparent transparent transparent;
}

.my-tooltip-top:hover .my-tooltiptext-top {
    visibility: visible;
}


.my-tooltip-bottom .my-tooltiptext-bottom {
    visibility: hidden;
    width: 150px;
    background-color: var(--main-blue);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 10px 5px 0px;
    position: absolute;
    z-index: 1;
    bottom: -90%;
    left: 35%;
    margin-left: -60px;
    z-index: 99999999;
}

.my-tooltip-bottom .my-tooltiptext-bottom::after {
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent var(--main-blue) transparent;
}

.my-tooltip-bottom:hover .my-tooltiptext-bottom {
    visibility: visible;
}


.process {
    padding: 80px 10px;
    // background-color: rgba(231, 231, 231, 0.356);
}

@media (min-width: 1200px) {
    .process .container {
        max-width: 1265px !important;
    }
}


.process .process-title {
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    color: var(--main-blue);

}

.process .title {
    color: var(--main-blue);
    margin-bottom: 100px;
    font-size: 20px;
}

.process .card {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 120px;
    border: double 8px transparent;
    border-radius: 50%;
    background-image: linear-gradient(white, white),
        linear-gradient(to bottom, #dddddd8e, #a8a8a8be);
    background-origin: border-box;
    background-clip: content-box, border-box;
    transition: all .5s;
}

.process .card-bottom:hover {
    transform: translateY(-10px);
    transition: all .5s;
}

.process .card-top:hover {
    transform: translateY(10px);
    transition: all .5s;
}

.process .card-border-bottom {
    position: absolute;
    content: "";
    width: 155px;
    height: 155px;
    border: 7px solid var(--main-blue);
    border-radius: 50%;
    border-bottom-color: transparent;
    border-left-color: transparent;
    transform: rotate(135deg);
    top: -18px;
    left: -3px;
    z-index: -1;
}

.process .card-border-top {
    position: relative;
    content: "";
    width: 155px;
    height: 155px;
    border: 7px solid var(--main-blue);
    border-radius: 50%;
    border-bottom-color: transparent;
    border-left-color: transparent;
    transform: rotate(-45deg);
    top: -136px;
    left: -18px;
    z-index: -1;
}


.process .line {
    border-bottom: 1px dashed;
    transform: rotateZ(-90deg);
    position: relative;
    left: 35px;
    width: 80px;
}

.process .larg-row .bottom {
    margin-left: -63px;
}

.process .larg-row .top {
    margin-left: -63px;
    margin-top: -15px;
    height: 104px;
}

@media (min-width: 1200px) {
    .process .larg-row {
        justify-content: center;
        // margin-right: -100px;
    }

    .tooltip-top {
        left: -28px !important;
        top: -10px !important;
    }

    .tooltip-bottom {
        top: 30px !important;
        left: -30px !important;
    }
}

@media (max-width: 1199px) {
    .process .larg-row {
        justify-content: space-around;
    }

    .tooltip-top {
        left: -3px !important;
        top: -10px !important;
    }

    .tooltip-bottom {
        top: 30px !important;
        left: -5px !important;
    }
}


// .process .card-top {
//     margin-left: -34px;
//     margin-top: -20px;
// }



.tech-tooltip .tooltip-inner {
    background: var(--main-blue) !important;
}

.tech-tooltip.bs-tooltip-top .arrow::before {
    border-top-color: var(--main-blue) !important;
}

.tech-tooltip.bs-tooltip-bottom .arrow::before {
    border-bottom-color: var(--main-blue) !important;
}



@media (min-width: 767px) {
    .process .twice {
        position: relative;
        left: 212px;
    }

    .tooltip-top2 {
        left: -103px !important;
        top: -10px !important;
    }

    .tooltip-bottom2 {
        top: -142px !important;
        left: -104px !important;
    }
}


@media (max-width: 767px) {
    .process .twice {
        position: relative;
        left: 22.5%;
    }

    .tooltip-top2 {
        left: -60px !important;
        top: -10px !important;
    }

    .tooltip-bottom2 {
        top: -142px !important;
        left: -59px !important;
    }
}


@media (max-width: 530px) {
    .process .twice {
        position: relative;
        left: 10%;
    }

    .tooltip-top2 {
        left: -20px !important;
        top: -10px !important;
    }

    .tooltip-bottom2 {
        top: -142px !important;
        left: -20px !important;
    }
}

@media (max-width: 320px) {
    .process .twice {
        position: relative;
        left: 1%;
    }
}









// .process .process-header {
//     font-size: 20px;
//     font-weight: bold;
//     color: var(--main-blue);
//     margin: 10px 0px 20px;
// }

// .process .process-discription {
//     font-size: 15px;
//     color: #646464;
//     text-align: center;
// }

// .process .numbers {
//     position: absolute;
//     top: 25px;
//     left: 0;
//     width: 100%;
//     color: #777;
//     font-size: 50px;
//     opacity: .2;
//     font-family: "Rubik-Bold", sans-serif !important;
// }

// .process .card {
//     border: none;
//     padding: 40px;
//     border-radius: 20px;
//     transition: all .5s;
//     height: 200px;
// }

// .process .my-card:hover {
//     .card {
//         box-shadow: 0px 11px 10px rgba(106, 106, 106, 0.253);
//         transform: translateY(-3px);
//         transition: all .5s;
//     }
//     .process-icon {
//         color: #fff;
//         background: var(--main-blue);
//         transition: all .5s;
//         border: 1px dashed #fff;
//     }
// }

// .process .process-icon {
//     color: var(--main-blue);
//     font-size: 70px;
//     margin: 20px;
//     border-radius: 50%;
//     border: 1px dashed var(--main-blue);
//     padding: 20px;
//     transition: all .5s;
// }

// @media (min-width: 992px) {
//     .card-bottom {
//         margin-top: 30px;
//     }
// }

// .process .before-enter {
//     opacity: 0;
//     // transform: translateY(100px);
//     transform: scale3d(0.5, 0.5, 0.5);
//     transition: all 1s ease-out;
// }

// .process .enter {
//     opacity: 1;
//     transform: scale3d(1, 1, 1);
//     // transform: translateY(0px);
// }
</style>